"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Injects the Facebook Pixel script near the top of the <head> tag
 * @param pixelId - Client ID
 */

exports.injectScriptTag = function () {
  var scriptTag = document.createElement("script"); // The script we're injecting is only defining a function which loads the
  // additional Facebook logic asychronously.  Injecting this script tag will
  // not block the browser, and allows us to call the `fbq` method without
  // needing to wait for the additional third-party logic to load.

  scriptTag.async = false;
  scriptTag.innerHTML = "\n        ! function(f, b, e, v, n, t, s) {\n            if (f.fbq) return;\n            n = f.fbq = function() {\n                n.callMethod ?\n                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)\n            };\n            if (!f._fbq) f._fbq = n;\n            n.push = n;\n            n.loaded = !0;\n            n.version = '2.0';\n            n.queue = [];\n            t = b.createElement(e);\n            t.async = !0;\n            t.src = v;\n            s = b.getElementsByTagName(e)[0];\n            s.parentNode.insertBefore(t, s)\n        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');\n    ";
  window.document.getElementsByTagName("head")[0].appendChild(scriptTag);
};